<style scoped lang="scss">
@import "../../style/color";

.head {
  height: 40px;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 1999;
  width: 100%;
  .user-info {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    a {
      color: #515a6e !important;
    }
    .logout {
      margin-left: 6px;
    }
    span {
      cursor: pointer;
      display: inline-block;
      &:hover {
        // color: $c_6DB;
      }
    }
  }
  .head-content,
  .header-logo-content {
    @include content;
    height: 40px;
  }

  .head-top {
    border-bottom: 1px solid $c_f7f;
  }

  .head-coordinate {
    &-logo {
      display: inline-block;
      height: 40px;
      // margin-right: 65px;
      width: 105px;
      // display: flex;
      // align-items: center;
      // justify-content: left;
      text-align: left;
      .img {
        width: 58px;
        height: 23px;
        margin: 7px 0 0 0;
        cursor: pointer;
      }
    }

    &-city {
      display: inline-block;
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 15px;
      @include borderLR(1px, $c_f3f);

      .name {
        margin: 0 10px 0 0;
        font-size: $font-sm;
        line-height: 13px;
        display: flex;
        align-items: center;
        float: left;
        margin-top: 0;
        color: $c_000;
        font-family: "EperFontLight";
      }

      .img {
        width: 23px;
        height: 32px;
        margin: 0;
        cursor: pointer;
      }
    }
  }

  .head-search {
    &-lang {
      padding-right: 20px;
      margin-left: 73px;

      .img {
        width: 30px;
        height: 30px;
        margin-top: 6px;
      }

      .arrow {
        right: 0;
        top: 18px;
        @include arrow($c_000);
      }
    }

    &-h {
      height: 40px;
      cursor: pointer;
    }

    &-cart {
      margin: 6px 0 0 70px;
      padding-right: 20px;
      cursor: pointer;
      .img {
        width: 34px;
        height: 30px;
      }

      .arrow {
        right: 0;
        top: 12px;
        @include arrow($c_000);
      }

      &-num {
        position: absolute;
        top: -5px;
        right: 15px;
        color: $c_fff;
        min-width: 17px;
        height: 17px;
        padding: 0 2px;
        line-height: 17px;
        background: $c_6DB;
        border-radius: 20px;
        font-size: $font-base;
        text-align: center;
      }

      &.-content {
        width: 467px;
        border: 1px solid $c_6DB;
      }
    }

    .head-search-input {
      margin-top: 2px;
      margin-right: 12px;
      .head-search-searchs {
        width: 392px;
        height: 36px;
        border: 1px solid $c_6DB;
        border-radius: 20px;

        .search-input {
          width: 350px;
          height: 34px;
          padding-left: 20px;
          box-sizing: border-box;
          font-size: $font_base;
          color: $c_000;
        }
        .search-input::placeholder {
          font-size: $font_sm;
          color: #b5b5b6;
          font-family: "EperFontLight";
        }

        .search-btn {
          width: 40px;
          height: 36px;
          background: url("../../assets/icon/header/search.png") no-repeat
            center center;
        }
      }
    }

    &-language-content {
      position: absolute;
      right: -2px;
      top: 50px;
      z-index: 5;
      background: $c_fff;
      height: 100px;
      border-radius: 4px;
      border: 1px solid $c_6DB;
      padding: 5px;
      box-sizing: border-box;
      font-family: "EperFontLight";

      .arrowBefore::before {
        position: absolute;
        top: -18px;
        left: 47px;
        z-index: 3;
        @include arrowBefore(6px, $c_6DB);
      }

      .arrowBefore::after {
        position: absolute;
        top: -17px;
        left: 47px;
        z-index: 3;
        @include arrowBefore(6px, $c_fff);
      }

      .icon {
        cursor: pointer;
        text-align: left;
        line-height: 30px;
        color: $c_000;
        font-size: $font_sm;
        padding-left: 37px;
        font-family: "EperFontLight";
        background: url("../../assets/icon/header/lang_en.jpg") no-repeat 2px
          center;
      }

      .icon.fr_fr {
        background: url("../../assets/icon/header/lang_fr.jpg") no-repeat 2px
          center;
      }

      .icon.zh_cn {
        background: url("../../assets/icon/header/lang_cn.png") no-repeat 2px
          center;
        font-weight: lighter;
      }

      .icon.active {
        background: $c_6DB;
      }

      .arrow {
        top: -13px;
        left: 30px;
        @include arrowTop($c_6DB);
      }
    }

    &-cart-content {
      cursor: pointer;
      width: 467px;
      border: 1px solid $c_6DB;
      position: absolute;
      right: -124px;
      top: 44px;
      z-index: 9999;
      background: $c_fff;
      border-radius: 10px;
      padding: 16px 9px;

      .arrow {
        top: -13px;
        left: 240px;
        @include arrowTop($c_6DB);
      }

      .arrowBefore::before {
        position: absolute;
        top: -29px;
        left: 300px;
        z-index: 3;
        @include arrowBefore(6px, $c_6DB);
      }

      .arrowBefore::after {
        position: absolute;
        top: -28px;
        left: 300px;
        z-index: 3;
        @include arrowBefore(6px, $c_fff);
      }

      &-product {
        overflow-y: scroll;
        max-height: 445px;
        padding: 0 11px;

        .cart-product {
          line-height: 40px;
          font-size: $font_base;
          border-bottom: 1px solid $c_f3f;

          .name {
            width: 195px;
            @include ellipsis;
            font-family: "EperFontLight";
            a:hover {
              color: $c_6DB !important;
            }
          }
          .price {
            font-family: "EperFontLight";
            color: #231f20;
          }
          .cart-num {
            max-width: 90px;
            min-width: 90px;
            margin: 0 10px 0 20px;

            .reduce,
            .plus {
              width: 16px;
              height: 16px;
              border-radius: 50px;
              background: $c_6DB;
              color: $c_fff;
              font-size: 15px;
              margin-top: 13px;
              font-family: "EperFontBold";
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              display: flex;
              span {
                display: block;
                line-height: 18px;
                text-align: center;
                position: absolute;
                left: 0;
                top: 0;
              }
            }
            .reduce span {
              top: -2px;
              left: 6px;
              color: #fff;
            }
            .plus span {
              top: -1px;
              left: 4px;
              color: #fff;
            }

            .cart-allnum {
              width: 35px;
              text-align: center;
              background: none;
              color: $c_6DB;
              &.cart-allnum-noadd {
                margin-left: 15px;
              }
            }
          }

          .delete {
            width: 25px;
            text-align: center;
            padding-top: 3px;
            height: 40px;

            .img {
              width: 13px;
              height: 17px;
            }
          }
        }
      }

      &-shopingCart {
        padding: 0 11px;

        .all-num {
          color: $c_6DB;
          font-size: $font-lg;
          padding: 10px 30px;
          span {
            color: $c_6DB;
          }
        }

        .look-cart {
          text-align: center;
          border-radius: 20px;

          .cart-btn {
            background: $c_6DB;
            line-height: 30px;
            padding: 0 25px;
            padding-top: 2px;
            color: $c_fff;
            border-radius: 20px;
          }
        }
      }
    }

    .search-result {
      // display: none;
      width: 365px;
      position: absolute;
      left: 12px;
      top: 35px;
      padding: 0 14px 16px;
      border: 1px solid $c_6DB;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
      z-index: 999;
      background: $c_fff;
      font-size: $font_base;
      &-area {
        text-align: center;
        line-height: 28px;

        .product-title {
          margin: 16px 0;
          border-bottom: 1px solid $c_6DB;
          color: $c_6DB;
        }

        .name {
          @include ellipsis();
          a {
            color: #333 !important;
            &:hover {
              color: $c_6DB !important;
            }
          }
          .productSearch {
            img {
              width: 40px;
              height: 40px;
              flex-shrink: 0;
            }
            span {
              padding-left: 5px;
              flex: 1;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            display: flex;
            align-items: center;
            padding: 5px 0;
          }
        }
      }
    }
  }
}
.zIndex {
  z-index: 2000;
}
.search_pic {
  width: 100%;
  // border-radius: 10px;
}
</style>
<template>
  <div
    class="head clearfix"
    :class="
      loadstate || loadCartState || searchText != '' || showCity ? 'zIndex' : ''
    "
  >
    <div class="head-special" v-if="isShow">
      <img src="../../assets/picture/1.jpg" alt="特殊广告" />
    </div>
    <div class="head-top">
      <div class="head-content">
        <div class="head-coordinate fl">
          <div class="head-coordinate-logo fl">
            <img
              class="img"
              src="../../assets/icon/header/small-logo.png"
              alt="logo"
              @click.stop="goIndex()"
            />
          </div>
          <div
            class="head-coordinate-city fl"
            @click="selectCity"
            v-if="!isShopcartPage"
          >
            <span class="name" ref="addressBox"
              >{{ cityName.toUpperCase() }}
              <span> &nbsp;</span>
              <span
                ><b>{{ tit }}</b></span
              >
            </span>
            <img
              class="img"
              src="../../assets/icon/header/coordinate.png"
              alt="地标"
            />
          </div>
        </div>
        <div class="head-search">
          <div
            class="head-search-h head-search-lang fr por"
            @mouseover.stop="showLang(true)"
            @mouseout.stop="showLang(false)"
          >
            <img
              class="img"
              src="../../assets/icon/header/roundLangIcon-zh.png"
              alt="language"
              v-if="lang == 'zh_cn'"
            />
            <img
              class="img"
              src="../../assets/icon/header/roundLangIcon-en.png"
              alt="language"
              v-if="lang == 'en_us'"
            />
            <img
              class="img"
              src="../../assets/icon/header/roundLangIcon-fr.png"
              alt="language"
              v-if="lang == 'fr_fr'"
            />

            <span class="arrow poa" v-if="!noChangeLang"></span>
            <div
              class="head-search-language-content"
              v-if="!noChangeLang"
              @mouseover.stop="showLang(true)"
              mouseout.stop="showLang(false)"
              v-show="loadstate"
            >
              <span class="arrowBefore poa"></span>
              <p
                :class="['icon', lang.locale]"
                v-for="(lang, i) in langList"
                :key="i"
                @click="langFun(lang.locale, lang.value)"
              >
                {{ lang.lang }}
              </p>
            </div>
          </div>

          <div
            class="head-search-h head-search-cart fr por"
            @mouseover.stop="showCart(true)"
            @mouseout.stop="showCart(false)"
            v-if="!isShopcartPage"
          >
            <img
              class="img"
              src="../../assets/icon/header/shopCart.png"
              @click="toShopcart"
              alt="shopCart"
            />
            <span class="arrow poa"></span>
            <span class="head-search-cart-num" v-if="cartNum">{{
              cartNum
            }}</span>
            <div
              class="head-search-cart-content"
              @mouseover.stop="showCart(true)"
              @mouseout.stop="showCart(false)"
              v-if="loadCartState && cartNum"
            >
              <span class="arrowBefore poa"></span>

              <div class="head-search-cart-content-product">
                <div
                  class="cart-product ovh"
                  v-for="(a, i) in cartList"
                  :key="i"
                >
                  <div class="name fl" @click="proDetail(a.productID)" :title="a.name">
                    {{ a.name }}
                  </div>
                  <div class="cart-num fl">
                    <div
                      class="reduce fl"
                      @click="
                        changeCartNum(a.shopCartProductID, 'min', a.num, i)
                      "
                      v-if="!a.isProm"
                    >
                      <span>-</span>
                    </div>
                    <input
                      class="cart-allnum fl"
                      :class="{ 'cart-allnum-noadd': a.isProm }"
                      type="text"
                      :disabled="a.isProm"
                      v-model="a.num"
                      @blur="
                        changeCartNum(a.shopCartProductID, 'mod', a.num, i)
                      "
                    />
                    <div
                      class="plus fl"
                      @click="
                        changeCartNum(a.shopCartProductID, 'plu', a.num, i)
                      "
                      v-if="!a.isProm"
                    >
                      <span>+</span>
                    </div>
                  </div>
                  <div class="price fl">￥{{ a.amount }}</div>
                  <div
                    class="delete fr"
                    @click="changeCartNum(a.shopCartProductID, 'del', a.num, i)"
                  >
                    <img
                      class="img inlineBlock"
                      src="../../assets/icon/header/reduce.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div class="head-search-cart-content-shopingCart">
                <div class="all-num ovh">
                  <span class="number fl"
                    >{{ num }} {{ $t("header.jian") }}</span
                  >
                  <span class="all-price fr">￥{{ CartTotalAmount }}</span>
                </div>
                <div class="look-cart" @click="toShopcart">
                  <button class="cart-btn">{{ $t("header.goCart") }}</button>
                </div>
              </div>
            </div>
          </div>

          <div
            class="head-search-h head-search-input fr por"
            v-if="!isShopcartPage"
          >
            <div class="head-search-searchs ovh">
              <input
                class="search-input fl"
                type="text"
                :placeholder="$t('header.searchText')"
                v-model.trim="searchText"
                @keyup="debounceInput"
                @keyup.enter="enterSearch"
                @focus="isShowResult = true"
                @blur="SetResultShow"
              />
              <button class="search-btn fl" @click.stop="doSearch()"></button>
            </div>
            <div
              class="search-result"
              v-if="
                searchText &&
                isShowResult &&
                (cataList.length > 0 ||
                  brandList.length > 0 ||
                  productList.length > 0)
              "
            >
              <div class="search-result-area" v-if="cataList.length">
                <h3 class="product-title">{{ $t("header.fenlei") }}</h3>
                <p class="name" v-for="(cata, index) in cataList" :key="index">
                  <!-- 分类搜索 -->
                  <router-link
                    :to="{
                      path: '/category',
                      query: {
                        WebFunctionID: '',
                        brandId: '',
                        ProductCataID: cata.Id,
                        isFromType: true,
                        isShowSelect: 1,
                        listtype: 'c',
                      },
                    }"
                    >{{ cata.Name }}</router-link
                  >
                </p>
              </div>
              <div class="search-result-area" v-if="brandList.length">
                <h3 class="product-title">{{ $t("header.brand") }}</h3>
                <p
                  class="name"
                  v-for="(brand, index) in brandList"
                  :key="index"
                >
                  <!-- 品牌搜索 -->
                  <router-link
                    :to="{
                      path: '/category',
                      query: {
                        WebFunctionID: '',
                        brandId: brand.Id,
                        ProductCataID: '',
                        isFromType: true,
                        isShowSelect: 1,
                      },
                    }"
                    >{{ brand.Name }}</router-link
                  >
                </p>
              </div>
              <div class="search-result-area" v-if="productList.length">
                <h3 class="product-title">{{ $t("header.pro") }}</h3>
                <p
                  class="name"
                  v-for="(product, index) in productList"
                  :key="index"
                >
                  <!-- 商品搜索 -->
                  <router-link
                    class="productSearch"
                    :to="{
                      path: '/productDetail',
                      query: {
                        id: product.Id,
                        ProductCataID: '',
                      },
                    }"
                    ><img :src="product.ImgUrl" alt="" />
                    <span>{{ product.Name }}</span></router-link
                  >
                </p>
              </div>
              <div class="search-result-area" v-if="searchPic.ImgUrl">
                <img
                  :src="searchPic.ImgUrl"
                  class="search_pic"
                  @click="common.NewlinkList(searchPic)"
                />
              </div>
            </div>
          </div>

          <div class="user-info fr" v-if="isShopcartPage">
            <template v-if="!token">
              <span @click="toLogin">{{ $t("headerNav.login") }}</span> /
              <span @click="toRegister">{{ $t("headerNav.register") }}</span>
            </template>
            <template v-else>
              <span @click="personCenter">{{ userInfo.TrueName }}</span>

              <span style="margin: 0 10px">|</span>
              <span class="logout" @click.stop="logout()">{{
                $t("headerNav.logout")
              }}</span>
              <!-- <span><router-link to="/user/userInfo">{{$t("headerNav.me")}}</router-link></span> -->
            </template>
          </div>
        </div>
      </div>
    </div>

    <v-selectLang
      :showLang="isShowLang"
      @closeLang="closeLang"
      @getLang="getLang"
    ></v-selectLang>
    <v-selectCity
      :leftpx="leftpx"
      :showCity="showCity"
      :showdevliy="showdevliy"
      @closeCity="closeCity"
      @getCity="getCity"
      @changeshowdevliy="changeshowdevliy"
    ></v-selectCity>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vSelectLang from "../index/selectLang.vue";
import vSelectCity from "../index/selectCity.vue";
import filter from "../../plugins/filters";
export default {
  name: "Header",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isShopcartPage: {
      type: Boolean,
      default: false,
    },
    isOrderPage: {
      type: Boolean,
      default: false,
    },
    cartPros: {
      type: Object,
      default: () => {},
    },
    noChangeLang: {
      type: Boolean,
      default: false,
    },
    isNewArea: {
      type: Boolean,
      default: false,
    },
    keyWords: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      shopcarInfo: "getShopcarInfo",
      needShowCartToSeconds: "needShowCartToSeconds",
    }),
  },
  components: {
    vSelectLang,
    vSelectCity,
  },
  data() {
    return {
      cityName: "",
      loadtimer: null,
      loadstate: false,
      loadCartTime: null,
      loadCartState: false,
      isShowLang: false,
      lang: "",
      langList: this.$store.state.epermarket_lang.locales,
      searchText: "",
      proNum: 0,
      cartNum: 0,
      cityInfo: {},
      showCity: false,
      showdevliy: false,
      token: filter.readData("userInfo")
        ? filter.readData("userInfo").Token
        : "",
      userInfo: filter.readData("userInfo") ? filter.readData("userInfo") : {},
      cataList: [],
      brandList: [],
      productList: [],
      cartList: [],
      CartTotalAmount: "",
      num: "",
      searchPic: {},
      leftpx: 0,
      tit: "",
      isShowResult: false,
      debounceInput: () => {},
    };
  },
  watch: {
    shopcarInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.cartInfo = newVal;
        //this.cartList = newVal.List;
        this.cartList = this.getSelectPro(newVal.ShopcartProEnableSort);
        this.cartNum = newVal.CartNum;
        this.num = newVal.CartNum;
        this.CartTotalAmount = newVal.CartTotalAmount;
        if (this.needShowCartToSeconds) {
          this.showCart(true);
          this.timer = setTimeout(() => {
            this.showCart(false);
          }, 50);
        }
      },
    },
    cityInfo: {
      deep: true,
      handler(newVal, oldVal) {
        if (filter.readData("lang") == 1) {
          this.cityName = newVal.CityName;
        }
      },
    },
    isNewArea: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.checkCity();
        }
      },
    },
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  created() {
    this.lang = this.checkLang();
    if (this.lang == "") {
      this.isShowLang = true;
    } else {
      this.isShowLang = false;
      this.checkCity();
    }
    this.searchText = this.keyWords;
  },
  mounted() {
    this.debounceInput = this.debounce(this.search, 800, false);
    this.selectLang();
    this.GetCartNum();
    if (!this.isShopcartPage) {
      this.GetCartPros();
    }

    if (this.cartPros) {
      // this.cartList = this.cartPros.List;
      this.cartList = this.getSelectPro(this.cartPros.ShopcartProEnableSort);
      this.CartTotalAmount = this.cartPros.CartTotalAmount;
    }
  },
  methods: {
    personCenter() {
      if (!this.token) {
        this.$router.push({
          path: "/login",
        });
      } else {
        this.$router.push({
          path: "/user/userInfo",
        });
      }
    },
    debounce(func, delay = 1000, immediate = false) {
      //闭包
      let timer = null;
      //不能用箭头函数
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        if (immediate && !timer) {
          func.apply(this, arguments);
        }
        timer = setTimeout(() => {
          func.apply(this, arguments);
        }, delay);
      };
    },
    SetResultShow() {
      setTimeout(() => {
        this.isShowResult = false;
      }, 300);
    },
    changeshowdevliy(val) {
      this.showdevliy = val;
    },
    selectLang() {
      let daystit = filter.readData("waysobj").DeliveryCycle
        ? filter.readData("waysobj").DeliveryCycle
        : ",,";
      let titArr = daystit.split(",");

      if (this.checkLang() == "zh_cn") {
        this.cityName = filter.readData("cityInfo").CityNameCn;

        if (titArr[0] == "") {
        } else {
          this.tit = " / " + titArr[0];
        }
      } else if (this.checkLang() == "en_us") {
        this.cityName = filter.readData("cityInfo").CityNameEn;
        if (titArr[0] == "") {
        } else {
          this.tit = " / " + titArr[1];
        }
      } else if (this.checkLang() == "fr_fr") {
        this.cityName = filter.readData("cityInfo").CityNameFr;
        if (titArr[0] == "") {
        } else {
          this.tit = " / " + titArr[2];
        }
      } else {
        this.cityName = filter.readData("cityInfo").CityNameCn;
        if (titArr[0] == "") {
        } else {
          this.tit = " / " + titArr[0];
        }
      }

      // DeliveryInfo;
      // console.log("days      ", days);
      // if (filter.readData("cityInfo")) {
      //   curcity.DeliveryInfo.forEach((val) => {
      //     if (val.DeliveryMode == days) {
      //       daystit = val.DeliveryCycle;
      //     }
      //   });

      //   console.log('daystit',daystit);

      // }
    },
    checkLang() {
      let lang = localStorage.getItem("lang");
      let locale = "";
      if (lang) {
        if (lang == 1) {
          locale = "zh_cn";
        } else if (lang == 2) {
          locale = "en_us";
        } else {
          locale = "fr_fr";
        }
      }
      return locale;
    },
    checkCity() {
      let city = JSON.parse(localStorage.getItem("cityInfo"));
      if (!city || city == null) {
        this.showCity = true;
      } else {
        this.showCity = false;
      }
    },
    langFun(lang, value) {
      this.$store.commit("set_lang", lang);
      filter.setData("lang", value);
      this.lang = lang;
      this.$i18n.locale = lang;
      if (lang == "zh_cn") {
        this.$store.commit("set_langType", 1, lang);
      } else if (lang == "en_us") {
        this.$store.commit("set_langType", 2, lang);
      } else if (lang == "fr_fr") {
        this.$store.commit("set_langType", 3, lang);
      }
      this.$router.go(0);
    },
    showCart(e) {
      this.loadCartTime && clearInterval(this.loadCartTime);
      if (!e) {
        this.loadCartTime = setTimeout(() => {
          this.loadCartState = e;
        }, 500);
      } else {
        this.loadCartState = e;
      }
    },
    showLang(e) {
      this.loadtimer && clearTimeout(this.loadtimer);
      if (!e) {
        this.loadtimer = setTimeout(() => {
          this.loadstate = e;
        }, 500);
      } else {
        this.loadstate = e;
      }
    },
    closeLang() {
      this.lang = this.checkLang();
      this.isShowLang = false;

      this.checkCity();
      this.selectLang();
    },
    toLogin() {
      this.$router.push({
        path: "/login",
        query: {
          redirectUrl: this.$route.fullPath,
        },
      });
    },
    toRegister() {
      this.$router.push({
        path: "/register",
      });
    },
    selectCity() {
      //console.log("城市选择");
      this.showdevliy = localStorage.getItem("waysobj") ? true : false;

      this.showCity = true;
    },
    closeCity(val) {
      this.showCity = val;
    },
    getLang(lang) {
      this.$router.go(0);
    },
    getCity(city) {
      this.cityName = city.CityName;
      let isIndex = this.$store.state.isIndex;
      if (isIndex == 1) {
        setTimeout(() => {
          // this.$router.go(0);
          this.$router.push({ path: "/" });
        }, 1200);
        this.$store.state.isIndex = 0;
      } else {
        setTimeout(() => {
          this.$router.go(0);
        }, 1200);
      }
    },
    setSearchText() {
      this.searchText = "";
    },
    doSearch() {
      if (this.searchText == "") return;
      this.enterSearch();
    },
    // 去购物车
    toShopcart() {
      this.$store.commit("needShowCartToSeconds", false);
      this.$router.push({ path: "/shopcart" });
    },
    logout() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("Token");
      localStorage.removeItem("nextShowCouponTemp");
      localStorage.removeItem("InviteCode");
      if (this.isOrderPage) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(0);
      }
    },
    //商品详情
    proDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: {
          id: id,
        },
      });
    },
    // 获取购物车数量
    GetCartNum() {
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      this.$store
        .dispatch("GetCartNum", {
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then(({ Data }) => {
          _this.cartNum = Data.CartNum;
        });
    },
    // 获取购物车商品
    GetCartPros() {
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      _this.$store
        .dispatch("GetCartPros", {
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then(({ Data }) => {
          //  _this.cartList = Data.List;

          _this.cartList = _this.getSelectPro(Data.ShopcartProEnableSort);
          _this.num = Data.CartNum;
          _this.CartTotalAmount = Data.CartTotalAmount;
          // _this.eventBus.$emit('addCartEvt')
        });
    },
    //获取已选中的商品
    getSelectPro(arr) {
      let tempArr = [];
      for (let i in arr) {
        if (arr[i].isSelected) {
          tempArr.push(arr[i]);
        }
      }
      return tempArr;
    },
    search() {
      // 关键词搜索
      const _this = this;
      if(!_this.searchText) return
      
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      const {CityID} = JSON.parse(localStorage.getItem("cityInfo"));
      _this.$store
        .dispatch("IntelligenceSearch", {
          Keyword: _this.searchText,
          isSign: true,
          CityID
        })
        .then(({ Data }) => {
          _this.cataList = Data.CataList;
          _this.brandList = Data.BrandList;
          _this.productList = Data.ProductList;
          if (Data.SearchAdsense && Data.SearchAdsense.length > 0) {
            _this.searchPic = Data.SearchAdsense[0];
          }
        });
    },
    //商品详情页
    toDetail(product) {
      // this.$router.push({
      //   path: '/productDetail',
      //   query: {
      //     id: product.ProductID
      //   }
      // })
      window.open("/productDetail?id=" + product.ProductID, "_blank");
    },
    // 购物车商品/加/减/删除
    // id 购物车中商品ID
    // operate 操作类型
    // num 购物车中该商品数量
    changeCartNum(id, operate, num, index) {
      const _this = this;
      let TempId = "";
      let tempNum = 1;
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      if (operate == "mod") {
        tempNum = num;
      } else {
        tempNum = 1;
      }

      let param = {
        scpid: id,
        num: tempNum,
        cartKind: 1,
        ckValue: 0,
        operate: operate,
        TempId,
        Token: localStorage.getItem("Token")
          ? localStorage.getItem("Token")
          : "",
      };
      _this.$store.dispatch("ChangeCartNum", param).then(({ Data }) => {
        _this.GetCartNum();
        _this.GetCartPros();
      });
    },
    //按回车键搜索
    enterSearch() {
      if (this.searchText == "") return;
      this.$router.push({
        path: "/searchList",
        query: {
          keyWords: this.searchText,
          record: true,
        },
      });
      // this.searchText = "";
    },
    goIndex() {
      window.location.href = "/";
      // this.$router.push({
      //   path: '/'
      // })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/public/Header.vue